export enum ESIGN {
  SIGN = "ESIGN_SIGN",
}

export enum ORDERS {
  EDIT = "ORDERS_EDIT",
  ADD = "ORDERS_ADD",
}

export enum USER_MANAGEMENT {
  VIEW = "USER_MANAGEMENT_VIEW",
  EDIT = "USER_MANAGEMENT_EDIT",
}
export enum DOCUMENTS {
  VIEW = "DOCUMENTS_VIEW",
  FILTER_BUTTONS = "DOCUMENTS_FILTER_BUTTONS",
}

export enum CONTRACT {
  REQUEST = "CONTRACT_REQUEST",
}
